import { render, staticRenderFns } from "./CustomerAddStaff.vue?vue&type=template&id=6da31680&"
import script from "./CustomerAddStaff.vue?vue&type=script&lang=js&"
export * from "./CustomerAddStaff.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAddStaff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports